export const FaqCities = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan", "lodz"];
export const FaqCities = ["warszawa", "krakow", "wroclaw", "gdansk", "poznan", "lodz"];
